export const V2_0 = ["Sidecar dark mode integration fixes", "Displaying version updates"];
